<template>
  <el-dialog
    class="dialogCreateTopic"
    :visible="true"
    title="Tạo nhắc hẹn"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :show-close="false"
    width="407px">
    <div
      slot="title"
      class="font-16 fw-500 text-center">
      TẠO NHẮC HẸN
    </div>
    <div
      class="flex-column mx-12 px-12 py-12 rounded-2"
      style="border: 1px solid #eaecf2">
      <div class="mb-2">
        Nhập nội dung
        <span class="text-red500">*</span>
      </div>
      <el-input
        type="textarea"
        resize="none"
        :rows="3"
        placeholder="Nhập nội dung hoặc dán liên kết"
        v-model="topic.title" />
      <div class="my-2">Chọn thời gian</div>
      <div class="d-flex justify-content-between align-items-center">
        <div
          v-for="item in quickTimeType"
          :key="item.val"
          class="z2-quicktime pointer px-2 py-1 font-13 fw-400"
          :class="item.val === quickTime && 'z2-quicktime-active'"
          @click="onChoseQuickTime(item.val)">
          {{ item.name }}
        </div>
      </div>

      <div class="d-flex justify-content-between">
        <div>
          <div class="my-2">Chọn ngày nhắc hẹn</div>
          <el-date-picker
            v-model="topic.startTime"
            type="datetime"
            placeholder="Chọn ngày nhắc hẹn"
            :disabled="quickTime !== 3"
            style="width: 224px !important"></el-date-picker>
        </div>
        <div>
          <div class="my-2">
            Lặp lại
            <span class="text-red500">*</span>
          </div>
          <el-select
            v-model="topic.repeat"
            style="width: 128px !important">
            <el-option
              v-for="(item, index) in repeatType"
              :key="index"
              :label="item.name"
              :value="item.val"></el-option>
          </el-select>
        </div>
      </div>

      <div class="d-flex mt-3 justify-content-end">
        <el-button
          type="info"
          @click="$emit('close')">
          Hủy
        </el-button>
        <el-button
          type="primary"
          :disabled="!topic.title || !topic.startTime"
          @click="createNewTopic()">
          Tạo nhắc hẹn
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["conversation"],
  data() {
    return {
      topic: {
        title: "",
        repeat: 0,
      },
      quickTime: "",
    };
  },
  computed: {
    repeatType() {
      return [
        { name: "Không lặp lại", val: 0 },
        { name: "Hàng ngày", val: 1 },
        { name: "Hàng tuần", val: 2 },
        { name: "Hàng tháng", val: 3 },
      ];
    },
    quickTimeType() {
      return [
        { name: "15 phút nữa", val: 0 },
        { name: "30 phút nữa", val: 1 },
        { name: "9:00 ngày mai", val: 2 },
        { name: "Khác", val: 3 },
      ];
    },
  },
  methods: {
    createNewTopic() {
      if (!this.topic.title) {
        this.alert("error", "Nhập nội dung");
        return;
      }
      if (!this.topic.startTime) {
        this.alert("error", "Bạn chưa chọn thời gian");
        return;
      }
      if (new Date(this.topic.startTime).getTime() < new Date().getTime()) {
        this.alert("error", "Nhập lại thời gian");
        return;
      }

      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        startTime: new Date(this.topic.startTime).getTime(),
        title: this.topic.title,
        repeat: this.topic.repeat,
      };
      this.$http.post(this.conversation.group ? "/api/message/createGroupTopic" : "/api/message/createTopic", request).then((resp) => {
        if (resp.data.error_code === -20017) {
          return this.alertError("Yêu cầu không thành công vì 2 bạn chưa kết bạn trên Zalo");
        }
        this.$emit("created", this.topic);
      });
      this.$emit("created", this.topic);
    },
    onChoseQuickTime(type) {
      this.quickTime = type;
      const currentDate = new Date();
      currentDate.setSeconds(0);
      switch (type) {
        case 0: {
          this.topic.startTime = new Date(currentDate.getTime() + 15 * 60000);
          break;
        }
        case 1: {
          this.topic.startTime = new Date(currentDate.getTime() + 30 * 60000);
          break;
        }
        case 2: {
          currentDate.setDate(currentDate.getDate() + 1);
          currentDate.setHours(9, 0, 0, 0);
          this.topic.startTime = currentDate;
          break;
        }
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.dialogCreateTopic {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.z2-quicktime {
  border: 1px solid #dcdfe9;
  border-radius: 4px;
  height: 32px;
}
.z2-quicktime-active {
  color: #1769d7;
  background-color: #e1edfd;
  border: none;
  font-weight: 500;
}
</style>